import React from 'react';

export default function EmptyComponent() {
    return null;
};